var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 99,
    height: 99,
    viewBox: "0 0 99 99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4356",
    "data-name": "Rectangle 4356",
    width: 34.113,
    height: 34.092,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close_icon",
    "data-name": "close icon",
    transform: "translate(-1593.846 -1564)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_283",
    "data-name": "Ellipse 283",
    cx: 49.5,
    cy: 49.5,
    r: 49.5,
    transform: "translate(1593.846 1564)",
    fill: "#ff8000"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11005",
    "data-name": "Group 11005",
    transform: "translate(1625.846 1596)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11004",
    "data-name": "Group 11004",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44715",
    "data-name": "Path 44715",
    d: "M34.051,31.8a2.433,2.433,0,0,1-3.816,1.835,4.623,4.623,0,0,1-.637-.568Q23.524,27,17.461,20.916c-.335-.337-.506-.334-.84,0q-6.115,6.15-12.256,12.274a2.471,2.471,0,0,1-2.58.783A2.415,2.415,0,0,1,.573,30.12a6.92,6.92,0,0,1,.509-.538q6.051-6.053,12.111-12.1c.338-.336.33-.508,0-.84Q7.039,10.53.912,4.392A2.535,2.535,0,0,1,.089,1.817,2.423,2.423,0,0,1,3.932.549a6.116,6.116,0,0,1,.541.507q6.033,6.03,12.054,12.073c.434.438.644.386,1.046-.02Q23.662,6.974,29.786.872A2.512,2.512,0,0,1,32.037.03a2.415,2.415,0,0,1,1.587,3.846,5.941,5.941,0,0,1-.578.629Q26.976,10.58,20.9,16.643c-.332.33-.348.5-.007.839q6.13,6.094,12.235,12.215a2.768,2.768,0,0,1,.928,2.1",
    transform: "translate(0 0)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close_icon.5e2808d4ebd1bfa7cdf1f3586065a7e9.svg";
export { ForwardRef as ReactComponent };